import {updateUnitImages} from '@/modules/ProjectModule/modules/UnitModule/api/unit.api';

export const getters = {
    imageIds: (state) => state.imageIds,
    images:   (state, getters, rootState, rootGetters) => {
        const images = rootGetters['media/images'];
        const imageIds = getters.imageIds;

        return images.filter(({ id }) => imageIds.indexOf(id) !== -1);
    },
}

export const actions = {
    async updateImages({ commit, getters }, data) {
        const id = getters.unitId;
        return updateUnitImages({ ...data, id })
        .then((data) => commit('UPDATE_IMAGES', { ...data }));
    },
    async removeImages({ dispatch }, imageIds) {
        return dispatch('updateImages', { imageIds, connected: false });
    },
}

export const mutations = {
    UPDATE_IMAGES: (state, data) => {
        const { connected, imageIds } = data;
        const clearPhase = data.hasOwnProperty('clear');
        if (clearPhase) {
            state.imageIds = [];
        }
        imageIds.map((imageId) => {
            if (clearPhase) {
                state.imageIds.push(imageId);
            } else {
                const index = state.imageIds.indexOf(imageId);

                if (connected && index === -1) {
                    state.imageIds.push(imageId);
                }
                if (false === connected && index !== -1) {
                    state.imageIds.splice(index, 1);
                }
            }
        });
    },
}
